import { Controller } from '@hotwired/stimulus'

const RESTORE_FOCUS_KEY = 'workloadFiltersRestoreFocus'
const DEBOUNCE_MS = 300

export default class extends Controller {
  static targets = ['search', 'page']

  connect() {
    if (sessionStorage.getItem(RESTORE_FOCUS_KEY)) {
      sessionStorage.removeItem(RESTORE_FOCUS_KEY)
      this.searchTarget.focus()
      const { length } = this.searchTarget.value
      this.searchTarget.setSelectionRange(length, length)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    this.pageTarget.value = 1
    this.submit()
  }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      sessionStorage.setItem(RESTORE_FOCUS_KEY, '1')
      this.element.requestSubmit()
    }, DEBOUNCE_MS)
  }
}
